import { safeSignInReturnPath } from '../lib/navigation/signInReturnPath.js';
import { redirect } from 'react-router';
import type { LoaderFunctionArgs } from 'react-router';
import type { SessionContext } from '@solidops/shared/identity';
import { ApiError, queryClient } from '../lib/api/client.js';
import { getSessionQueryOptions } from '../lib/api/queries.js';
function signInPath(requestUrl: string): string {
  const url = new URL(requestUrl);
  const path = safeSignInReturnPath(
    url.pathname === '/account/contacts/verify'
      ? url.pathname
      : url.pathname + url.search + url.hash,
  );
  return path ? `/sign-in?returnTo=${encodeURIComponent(path)}` : '/sign-in';
}

export async function loader({
  request,
}: LoaderFunctionArgs): Promise<SessionContext | Response | null> {
  const url = new URL(request.url);
  if (
    url.pathname === '/account/contacts/verify' &&
    url.searchParams.get('status') === 'unavailable'
  )
    return null;
  try {
    return await queryClient.query(
      getSessionQueryOptions({ request: { headers: { 'x-solidops-activity': 'foreground' } } }),
    );
  } catch (error) {
    if (error instanceof ApiError && error.status === 401) return redirect(signInPath(request.url));
    throw error;
  }
}
